/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {SettlementDetailFooterConfigurationModel} from './models/settlement-detail-footer-configuration.model';
import {SettlementDetailFooterActionsEnum} from '../../models/settlement-detail-footer-actions.enum';

const SETTLEMENT_DETAIL_FOOTER_CONFIGURATION: SettlementDetailFooterConfigurationModel = {
    primaryButton: {
        label: 'Accept',
        disable: true,
        action: SettlementDetailFooterActionsEnum.ACCEPT,
        class: 'btn-secondary'
    },
    secondaryButton: {
        label: 'Reject',
        disable: true,
        action: SettlementDetailFooterActionsEnum.REJECT,
        class: 'btn-text-link'
    }
};

const SETTLEMENT_DISPLAY_CONFIGURATION_CONSTANTS = {
    header: {
        exportPdfButtonLabel: 'Export PDF'
    },
    title: {
        agreement: 'Settlement agreement(s)'
    },
    footer: {
        settlementDetail: SETTLEMENT_DETAIL_FOOTER_CONFIGURATION
    }
};

export default SETTLEMENT_DISPLAY_CONFIGURATION_CONSTANTS;
